// Admin-shell interactivity: a global "layout" store driving the responsive
// sidebar (drawer on mobile, static on desktop) plus small dropdowns.
import type { Alpine } from "alpinejs";

interface LayoutStore {
  sidebarOpen: boolean;
  openSidebar(): void;
  closeSidebar(): void;
  toggleSidebar(): void;
}

export function registerShell(alpine: Alpine): void {
  const layout: LayoutStore = {
    // Mobile drawer state (desktop keeps the sidebar always visible via CSS).
    sidebarOpen: false,
    openSidebar() {
      this.sidebarOpen = true;
    },
    closeSidebar() {
      this.sidebarOpen = false;
    },
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
  };

  alpine.store("layout", layout);

  // Close the mobile drawer whenever the viewport grows to desktop width.
  const desktop = window.matchMedia("(min-width: 1024px)");
  desktop.addEventListener("change", (e) => {
    if (e.matches) {
      (alpine.store("layout") as LayoutStore).sidebarOpen = false;
    }
  });
}
